enum Lessons {
  POLISH = "polish",
  MATH = "math",
  ALIEN = "alien",
}
export default Lessons
